module.exports = __webpack_public_path__ + "media/react/components/Calls/Calendar/assets/chevron-up-31c6f2660ea4bfbf93e0094813cb14b8.svg";